module.exports = __webpack_public_path__ + "img/terrainpetanque.43795e1d.jpg";